import { render, staticRenderFns } from "./Coupuser.vue?vue&type=template&id=1ebb21a0&scoped=true"
import script from "./Coupuser.vue?vue&type=script&lang=js"
export * from "./Coupuser.vue?vue&type=script&lang=js"
import style0 from "./Coupuser.vue?vue&type=style&index=0&id=1ebb21a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb21a0",
  null
  
)

export default component.exports